import { Component, OnInit, NgZone } from '@angular/core';
import { ServiceStock } from '../service-stock.service';
import { FcmNotificationService } from '../fcm-notification.service';

declare let $: any;

@Component({
  selector: 'app-starter',
  templateUrl: './starter.component.html',
  styleUrls: ['./starter.component.scss']
})
export class StarterComponent implements OnInit {

  gotoPath: string = "";
  showResumeWarning: boolean = false;
  constructor(private services: ServiceStock,
    private fcmService: FcmNotificationService, private ngZone: NgZone) { }

  ngOnInit() {
    var _this = this;
    if (!this.services.mobile.isHybrid()) {
      this.services.onboarding.doResume = false;
      this.services.showSpinner();
      this.onFetchRegDraftSuccess(null);
    } else {
      this.fcmService.checkPushPayload(function (response) {
        if (response) return;
        _this.services.onboarding.doResume = false;
        if (_this.services.mobile.isPINConfigured) {
          this.ngZone.run(() => {
            _this.services.router.navigate(['/welcome/appnavigator']);
            });
        } else {
          _this.services.showSpinner();
          _this.onFetchRegDraftSuccess(null);
        }
      });
    }
  }
  ngAfterViewInit() { }

  onFetchRegDraftSuccess(value) {
    this.services.hideSpinner();
    if (value) {
      if (this.services.mobile.isHybrid()) {
        setTimeout(() => {
          (<any>window).navigator.splashscreen.hide();
          setTimeout(() => {
            this.services.onboarding.doResume = true;
            this.gotoPath = value;
            this.showResumeWarning = true;
          }, 100);
        }, 100);
      } else {
        this.services.onboarding.doResume = true;
        this.gotoPath = value;
        this.showResumeWarning = true;
      }
    } else {
      
      this.ngZone.run(() => {
        this.services.router.navigate(['/welcome', 'appnavigator']);
        });
    }
  }

  resumeOnboarding() {
   
    this.ngZone.run(() => {
      this.services.router.navigate(["/onboarding", this.gotoPath]);
      });
  }

}
